export default __webpack_public_path__ + "static/media/iam_grid_xl.dac7506f.jpg";